import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { offer } from '../data/offer';
type InlineCtaProps = {
  dark?: boolean;
  label?: string;
};
export function InlineCta({
  dark = false,
  label = 'Voglio il pack completo'
}: InlineCtaProps) {
  return <Reveal className="mt-9 text-center" data-id="element-159" data-mp="26mne5i2kdkf0">
      <CtaButton data-id="element-160" data-mp="26noxsaxnbf8c">
        {label} — {offer.price}
      </CtaButton>
      <p className={`mt-3 text-[13px] ${dark ? 'text-sand' : 'text-ink-muted'}`} data-id="element-161" data-mp="2bmi4nkifg7zj">
        Pagamento unico · Accesso immediato · PDF via email
      </p>
    </Reveal>;
}